import { memo } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { zeroPad } from 'react-countdown';

import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { bodyText } from '@/styles/styles';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

type Props = {
  name: string;
  order: number | null;
  to: string;
  className?: ClassNameComponent;
};

const LessonNameMember = memo((props: Props) => {
  const { name, order, to, className } = props;
  const hasOrder = typeof order === 'number';

  return (
    <Link
      to={to}
      className={twMerge(
        'flex gap-4 items-center grow overflow-x-hidden cursor-pointer break-words',
        className?.base,
      )}
    >
      <span className="w-full h-fit overflow-x-hidden flex gap-1">
        <ConditionalRenderer condition={hasOrder}>
          {hasOrder && (
            <p
              className={twMerge(
                bodyText,
                'text-base-content/40',
                className?.prefix,
              )}
            >
              {zeroPad(order, 2)}.
            </p>
          )}
        </ConditionalRenderer>
        <p
          className={twMerge(
            bodyText,
            'text-base-content text-break',
            className?.text,
          )}
        >
          {name}
        </p>
      </span>
    </Link>
  );
});

export default LessonNameMember;
